import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../application/AuthContext';
import { PasswordToggleButton } from '../components/PasswordToggleButton';
import '../styles/auth.css';

export function LoginPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuthContext();
    const [form, setForm] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [errorType, setErrorType] = useState('error');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const from = location.state?.from || '/';
    const set = (field) => (e) => {
        setForm((f) => ({ ...f, [field]: e.target.value }));
        if (error) setError('');
    };

    async function handleSubmit(e) {
        e.preventDefault();
        if (!form.email || !form.password) {
            setError('이메일과 비밀번호를 입력해주세요.');
            setErrorType('error');
            return;
        }
        setError('');
        setLoading(true);
        try {
            const data = await login(form.email, form.password);
            if (data.role === 'COMPANY' && data.companyStatus !== 'APPROVED') {
                navigate('/company/profile', { replace: true });
                return;
            }
            navigate(from, { replace: true });
        } catch (err) {
            if (err.status === 403) {
                setError(err.message);
                setErrorType('warning');
            } else if (err.status === 401) {
                setError('이메일 또는 비밀번호가 올바르지 않습니다.');
                setErrorType('error');
            } else {
                setError(err.message || '요청에 실패했습니다.');
                setErrorType('error');
            }
        } finally {
            setLoading(false);
        }
    }

    const hasInputError = error && errorType === 'error';
    const hasWarning = error && errorType === 'warning';

    return (
        <div className="auth-page">
            <div className="auth-card">
                <Link to="/" className="auth-card__logo">
                    <img src="/images/logo/main_logo.png" alt="RISING BROKERS" />
                </Link>
                <div className="auth-card__title">로그인</div>
                <div className="auth-card__sub">라이징브로커즈에 오신 것을 환영합니다</div>

                {hasWarning && (
                    <div key={error} className="auth-alert auth-alert--warning">
                        {error}
                    </div>
                )}

                <form className="auth-form" onSubmit={handleSubmit} noValidate>
                    <div className="auth-field">
                        <label>이메일</label>
                        <input
                            className={`auth-input${hasInputError ? ' auth-input--error' : ''}`}
                            type="email"
                            placeholder="example@email.com"
                            value={form.email}
                            onChange={set('email')}
                            autoComplete="email"
                            autoFocus
                        />
                    </div>

                    <div className="auth-field">
                        <label>비밀번호</label>
                        <div className="auth-input-wrap">
                            <input
                                className={`auth-input${hasInputError ? ' auth-input--error' : ''}`}
                                type={showPassword ? 'text' : 'password'}
                                placeholder="비밀번호 입력"
                                value={form.password}
                                onChange={set('password')}
                                autoComplete="current-password"
                            />
                            <PasswordToggleButton
                                visible={showPassword}
                                onToggle={() => setShowPassword((v) => !v)}
                            />
                        </div>
                    </div>

                    {hasInputError && (
                        <p key={error} className="auth-form-error">{error}</p>
                    )}

                    <button className="auth-submit" type="submit" disabled={loading}>
                        {loading ? '로그인 중...' : '로그인'}
                    </button>
                    <p style={{ marginTop: 10, fontSize: 12, color: '#9ca3af', textAlign: 'center' }}>
                        원활한 이용을 위해 Chrome, Edge 등 최신 브라우저 사용을 권장합니다.
                    </p>
                </form>

                <div className="auth-links">
                    <Link to="/register">회원가입</Link>
                    <span>·</span>
                    <Link to="/forgot-password">비밀번호 찾기</Link>
                </div>
            </div>
        </div>
    );
}
